import { render, staticRenderFns } from "./rewardEggEdit.vue?vue&type=template&id=b4280e40&scoped=true&"
import script from "./rewardEggEdit.vue?vue&type=script&lang=js&"
export * from "./rewardEggEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4280e40",
  null
  
)

export default component.exports